export const TIME_CONSTANTS = {
  ONE_WEEK_MS: 604800000,
  ONE_MONTH_MS: 2592000000,
  THREE_DAYS_MS: 259200000,
  COUNTDOWN_RESET: 300,
  SECONDS_PER_HOUR: 3600,
  HOURS_PER_DAY: 24,
};

export const PROGRESS_THRESHOLDS = {
  WARNING: 51,
  DANGER: 91,
};

export const PROGRESS_COLORS = {
  SUCCESS: "#52c41a",
  WARNING: "#faad14",
  DANGER: "#ff4d4f",
  BEYOND: "#fadb14",
};
